// Visuel de secours pour un cours sans image de couverture : un monogramme
// généré à partir de son code, plutôt qu'une même photo générique répétée
// sur toutes les cartes. La couleur et le motif sont déterministes (même
// cours = même visuel à chaque rendu).

const PALETTES = [
  { bg: "hsl(var(--primary))", pattern: "hsl(var(--primary-foreground) / 0.12)" },
  { bg: "hsl(var(--accent))", pattern: "hsl(var(--accent-foreground) / 0.14)" },
  { bg: "hsl(var(--campus-green))", pattern: "#ffffff22" },
  { bg: "#1f2937", pattern: "#ffffff14" },
];

function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

function initialsFrom(code, title) {
  const source = (code || title || "?").trim();
  if (/^[A-Za-z]{2,4}-?\d*/.test(source) && code) {
    const letters = code.replace(/[^A-Za-z]/g, "").slice(0, 3);
    if (letters.length >= 2) return letters.toUpperCase();
  }
  const words = (title || source).split(/\s+/).filter(Boolean);
  return words.slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
}

export default function CourseMonogram({ code, title, className }) {
  const key = code || title || "cours";
  const hash = hashString(key);
  const palette = PALETTES[hash % PALETTES.length];
  const initials = initialsFrom(code, title);
  const patternId = `monogram-pattern-${hash}`;

  return (
    <svg viewBox="0 0 320 180" className={className} preserveAspectRatio="xMidYMid slice" role="img" aria-label={title || code}>
      <defs>
        <pattern id={patternId} width="26" height="26" patternUnits="userSpaceOnUse" patternTransform={`rotate(${hash % 45})`}>
          <line x1="0" y1="0" x2="0" y2="26" stroke={palette.pattern} strokeWidth="10" />
        </pattern>
      </defs>
      <rect width="320" height="180" fill={palette.bg} />
      <rect width="320" height="180" fill={`url(#${patternId})`} />
      <text
        x="24"
        y="118"
        fontFamily="'Cabinet Grotesk','IBM Plex Sans',sans-serif"
        fontWeight="800"
        fontSize="64"
        fill="#ffffff"
        opacity="0.95"
      >
        {initials}
      </text>
    </svg>
  );
}
